import React from 'react'
import Contactus from './shared/Contactus'
import Subbanner from './shared/Sub-banner'

const Contact = () => {
  return (
      <main>
        <Subbanner />
        <Contactus />
    </main>
  )
}

export default Contact